module.exports = __webpack_public_path__ + "img/circle-times-solid.48b5ee93.svg";